import { render, staticRenderFns } from "./GlossaryTermDescription.vue?vue&type=template&id=87c127b2&scoped=true"
import script from "./GlossaryTermDescription.vue?vue&type=script&lang=js"
export * from "./GlossaryTermDescription.vue?vue&type=script&lang=js"
import style0 from "./GlossaryTermDescription.vue?vue&type=style&index=0&id=87c127b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c127b2",
  null
  
)

export default component.exports